import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		env: {
			isWx: false,
			isMobile: false,
			isIE: false
		},
		breadcrumb: [],
		sortActive: 2,
		selectedArr: [],
		worksDetails: {},
		imgListNum: 0,
		searchWorksType: 0, // 0, 相机赛区，1，手机赛区，2. 特别关注
		radioText: ["相机赛区", "手机赛区"],
		step: 0, //投稿阶段，0，征稿日期，1，投票阶段,
	},
	plugins: [ createPersistedState({ storage: window.sessionStorage })],
	getters: {
		/**
		 * 7月2日以后显示投票相关功能
		 * @param {*} state 
		 * @returns 
		 */
		// voteIntroShow: state => {
		// 	return new Date().getTime() >= new Date("2022-07-01 00:00:00").getTime();
		// 	// return state.step === 1 || false;
		// 	// return true
		// },
		/**
		 * 征稿日期时间范围(2022/5/1-2022/6/30)
		 * @param {*} state 
		 * @returns 
		 */
		// isUpload: state => {
		// 	let date1 = new Date("2022-04-30 00:00:00").getTime();
		// 	let date2 = new Date("2022-06-30 23:59:59").getTime();
		// 	const date = new Date().getTime();
		// 	return date >= date1 && date <= date2;
		// 	// return true;
		// }
	},
	mutations: {
		/**
     * 设置环境信息
     * @param {*} state 
     * @param {*} val 
     */
		setEnv(state, val) {
			state.env[val.prop] = val.flag;
		},
		/**
     * 设置面包屑
     * @param {*} state 
     * @param {*} options 
     */
		setBreadcrumb(state, options) {
			state.breadcrumb = options;
		},
		/**
     * 设置排序方式
     * @param {*} state 
     * @param {*} val 
     */
		setSortActive(state, val) {
			state.sortActive = val;
		},
		/**
     * 设置已选作品
     * @param {*} state 
     * @param {*} val 
     */
		setSelectedArr(state, options) {
			if (Array.isArray(options)) {
				state.selectedArr = [];
				return;
			}
			if (options.status) {
				if(state.selectedArr.indexOf(options.value) !== -1) {
					return
				}
				state.selectedArr.push(options.value);
			} else {
				let i = state.selectedArr.indexOf(options.value);
				state.selectedArr.splice(i, 1);
			}
		},
		/**
     * 设置作品详情
     * @param {*} state 
     * @param {*} val 
     */
		setWorksDetails(state, val) {
			state.worksDetails = val;
		},
		/**
		 * 查询的图片列表的图片数量
		 */
		setImgListNum(state, length) {
			state.imgListNum = length;
		},

		/**
		 * 设置搜索作品的排序方式
		 */
		setSearchWorksType(state, type) {
			state.searchWorksType = type;
		},

		setStep(state, step) {
			state.step = step;
		}
	}
});
